import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import CONSTANTS from "../util/constants";
import { useDispatch, useSelector } from "react-redux";
import Encrypt from "./../util/encrypt";
import { exportFile } from "../util/exportFile";

const TrailersComp = () => {
  const dispatch = useDispatch();
  const gridRef = useRef();
  const [loginResponse, setLoginResponse] = useState(null);
  const [cellData, setCellClickData] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [isShowLog, isShowLogClicked] = useState(false);
  const rowDataRural = useSelector(
    (state) => state.ruralTrailer.getRuralTrailersData
  );
  const rowDataRuralLog = useSelector(
    (state) => state.ruralTrailer.getRuralTrailerLogsData
  );
  const divisionSelectedTemp = useSelector(
    (state) => state.division.divisionSelected
  );

  useEffect(() => {
    let localstorageLR = localStorage.getItem("L_R");
    if (localstorageLR) {
      let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : "";
      let loginResponse = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)
          : ""
        : "";
      setLoginResponse(loginResponse);
    }

    setCellClickData(null);

    dispatch({
      type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT
        .GET_RURAL_TRAILER_MANAGEMENT_API_CALL,
    });
  }, []);

  useEffect(() => {
    let rowDataRuralActtiveStatus = rowDataRural;
    let filterData = rowDataRuralActtiveStatus?.filter((item) => {
      return divisionSelectedTemp?.value == item.division_id;
    });
    setRowData(filterData);
  }, [rowDataRural]);

  const cellLogStyle = (params) => {
    return (
      <div
        onClick={() => {
          setCellClickData(params.data);
          dispatch({
            type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT
              .GET_RURAL_TRAILER_LOGS_API_CALL,
            payload: { value: params.data },
          });
          isShowLogClicked(true);
        }}
      >
        <p
          style={{
            width: "100%",
            height: "70%",
            backgroundColor: "rgb(0, 42, 74)",
            color: "white",
            borderRadius: 5,
            margin: 0,
            padding: "5px 10px",
            fontSize: 11,
          }}
        >
          {" "}
          <strong>{"Show Log"}</strong>{" "}
        </p>
      </div>
    );
  };

  const formatAMPM = (date) => {
    // This is to display 12 hour format like you asked
    var hours = date.getHours();
    var minutes = date.getMinutes();
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes;
    return strTime;
  };

  const [columnDefs] = useState([
    {
      headerName: "Trailer No",
      field: "btId",
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Current Location",
      filter: true,
      resizable: true,
      flex: 1,
      valueGetter: (params) => {
        console.log("paramsparams", params);
        let Location =
          params?.data?.lotName !== null
            ? `${params?.data?.lotName}_${params?.data?.spaceNumber}`
            : params?.data?.currentDoor !== null
            ? `${params?.data?.doorType}_${params?.data?.number}`
            : params?.data?.currentLocationNew !== null
            ? params?.data?.currentLocationNew
            : "Unknown";
        return Location;
      },
    },
    {
      headerName: "Trailer Capacity",
      field: "currentLoad",
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Status",
      field: "status",
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Seal Number",
      field: "sealNum",
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Product Number",
      field: "productNum",
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Actual Count",
      field: "actualCount",
      filter: true,
      resizable: true,
      flex: 1,
    },

    {
      field: "Logs",
      filter: true,
      resizable: true,
      flex: 1,
      cellRenderer: cellLogStyle,
      cellClass:
        "border-radius-md  text-center me-4 d-flex align-items-center justify-content-center",
    },
  ]);

  const [columnDefsLog] = useState([
    {
      headerName: "Date",
      field: "createdAt",
      filter: true,
      resizable: true,
      flex: 1,
      valueGetter: (params) => {
        let myDate =
          params?.data?.createdAt != null && params?.data?.createdAt != ""
            ? new Date(params?.data?.createdAt)
            : "";
        let dateTimeFormat =
          myDate.getMonth() +
          1 +
          "/" +
          myDate.getDate() +
          "/" +
          myDate.getFullYear() +
          " " +
          formatAMPM(myDate);
        return dateTimeFormat;
      },
    },
    {
      headerName: "Type",
      field: "logType",
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Volume Change",
      field: "volumeChange",
      filter: true,
      resizable: true,
      flex: 1,
      valueGetter: (params) => {
        let volume =
          params?.data?.volumeChange != null &&
          params?.data?.volumeChange == true
            ? params?.data?.prevVolume + "->" + params?.data?.currentVolume
            : "";
        return volume;
      },
    },
    {
      headerName: "User",
      field: "driver",
      filter: true,
      resizable: true,
      flex: 1,
      valueGetter: (params) => {
        let user =
          params?.data?.driver != null
            ? params?.data?.driver?.firstName +
              " " +
              params?.data?.driver?.lastName
            : "";
        return user;
      },
    },
    {
      headerName: "Relocation",
      field: "relocation",
      filter: true,
      resizable: true,
      flex: 1,
      valueGetter: (params) => {
        let prevLocation =
          params?.data?.previousDoor != null
            ? params?.data?.previousDoor?.doorType +
              "_" +
              params?.data?.previousDoor?.number
            : params?.data?.previousSpace != null
            ? params?.data?.previousSpace?.lot?.lotName +
              "_" +
              params?.data?.previousSpace?.btId
            : params?.data?.prevLocation != null
            ? params?.data?.prevLocation
            : "UNKNOWN";

        let isArrow = prevLocation != "" ? "->" : "";

        let currentLocation =
          params?.data?.currDoor != null
            ? params?.data?.currDoor?.doorType +
              "_" +
              params?.data?.currDoor?.number
            : params?.data?.currSpace != null
            ? params?.data?.currSpace?.lot?.lotName +
              "_" +
              params?.data?.currSpace?.btId
            : params?.data?.currentLocation != null
            ? params?.data?.currentLocation
            : "UNKNOWN";

        let volume = prevLocation + isArrow + currentLocation;
        return volume;
      },
    },
  ]);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    resizable: true,
  }));

  const cellClickedListener = useCallback((event) => {}, []);

  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.paginationGoToPage(1);
  }, []);

  return (
    <div className="row">
      <div className="col-md-12 col-sm-12 col-12">
        {isShowLog ? (
          <div
            className="col-md-12 col-sm-12 ag-theme-alpine"
            style={{
              display: "flex",
              flexDirection: "column",
              height: "80vh",
              width: "80vw",
              justifyContent: "space-between",
            }}
          >
            <div
              onClick={() => {
                isShowLogClicked(false);
              }}
              className="row wrapper col-8 col-md-4 col-sm-6 col-lg-3"
              style={{
                marginLeft: 12,
                marginBottom: 5,
                height: "4vh",
                width: "auto",
                backgroundColor: "darkGray",
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <label
                style={{
                  fontSize: "1.1em",
                  color: "white",
                  textAlign: "center",
                }}
              >
                {"Show All Trailers"}
              </label>
            </div>

            <div
              className="col-12 col-lg-12 col-md-12 col-sm-12 "
              style={{
                height: "40vh",
              }}
            >
              <div
                className="col-12 collg-12 col-md-12 col-sm-12 "
                style={{
                  display: "flex",
                  height: "6vh",
                  backgroundColor: "#0dcaf0",
                  border: "2px solid rgba(0, 0, 0, 0.1)",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label style={{ fontSize: 18, color: "white" }}>
                  {"Rural Hall Trailer :"}
                  {cellData?.btId}
                </label>
              </div>

              <div
                className="col-12 col-lg-12 col-md-12 col-sm-12 "
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "30vh",
                  backgroundColor: "white",
                  border: "2px solid rgba(0, 0, 0, 0.1)",
                }}
              >
                <div
                  className="row col-12 col-lg-12 col-md-12 col-sm-12 "
                  style={{
                    display: "flex",
                    height: "10vh",
                    backgroundColor: "white",
                    borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    className=" col-12 col-lg-6 col-md-6 col-sm-12 "
                    style={{
                      backgroundColor: "white",
                    }}
                  >
                    <label style={{ fontSize: 14, color: "black" }}>
                      {"Trailer : \n"}
                      {cellData?.btId}
                    </label>
                  </div>
                  <div
                    className=" col-12 col-lg-6 col-md-6 col-sm-12 "
                    style={{
                      backgroundColor: "white",
                    }}
                  >
                    <label style={{ fontSize: 14, color: "black" }}>
                      {"Current Location : \n"}
                      {rowDataRuralLog && rowDataRuralLog?.length > 0
                        ? rowDataRuralLog[0]?.currentDoor != null
                          ? (rowDataRuralLog[0]?.currDoor?.doorType || "") +
                            "_" +
                            (rowDataRuralLog[0]?.currDoor?.number || "")
                          : rowDataRuralLog[0]?.currentSpace != null
                          ? (rowDataRuralLog[0]?.currSpace?.lot?.lotName ||
                              "") +
                            "_" +
                            (rowDataRuralLog[0]?.currSpace?.btId || "")
                          : rowDataRuralLog[0]?.currentLocation != null
                          ? rowDataRuralLog[0]?.currentLocation
                          : "Unknown"
                        : "Unknown"}
                    </label>
                  </div>
                </div>

                <div
                  className="row col-12 col-lg-12 col-md-12 col-sm-12"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "10vh",
                    backgroundColor: "white",
                    borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <div
                    className=" col-12 col-lg-6 col-md-6 col-sm-12 "
                    style={{
                      backgroundColor: "white",
                    }}
                  >
                    <label style={{ fontSize: 14, color: "black" }}>
                      {"Current Trailer Capacity : \n"}
                      {cellData?.currentLoad}
                    </label>
                  </div>

                  <div
                    className=" col-12 col-lg-6 col-md-6 col-sm-12 "
                    style={{
                      backgroundColor: "white",
                    }}
                  >
                    <label style={{ fontSize: 14, color: "black" }}>
                      {"Seal Number : \n"}
                      {cellData?.sealNum}
                    </label>
                  </div>
                </div>

                <div
                  className="row col-12 col-lg-12 col-md-12 col-sm-12 "
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "10vh",
                    backgroundColor: "white",
                    borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <div
                    className=" col-12 col-lg-6 col-md-6 col-sm-12 "
                    style={{
                      backgroundColor: "white",
                    }}
                  >
                    <label style={{ fontSize: 14, color: "black" }}>
                      {"Product Number : \n"}
                      {cellData?.productNum}
                    </label>
                  </div>

                  <div
                    className=" col-12 col-lg-6 col-md-6 col-sm-12 "
                    style={{
                      backgroundColor: "white",
                    }}
                  >
                    <label style={{ fontSize: 14, color: "black" }}>
                      {"Actual Count : \n"}
                      {cellData?.actualCount}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-md-12 col-sm-12 ag-theme-alpine"
              style={{
                height: "40vh",
                width: "80vw",
                margin: "auto",
              }}
            >
              <AgGridReact
                ref={gridRef}
                suppressColumnVirtualisation={true}
                defaultColDef={defaultColDef}
                animateRows={true}
                onCellClicked={cellClickedListener}
                rowData={rowDataRuralLog}
                pagination={false}
                paginationAutoPageSize={false}
                paginationPageSize={10}
                paginateChildRows={false}
                enableRangeSelection={false}
                suppressRowClickSelection={false}
                groupSelectsChildren={false}
                rowSelection={"multiple"}
                rowGroupPanelShow={"always"}
                pivotPanelShow={"always"}
                columnDefs={columnDefsLog}
                onFirstDataRendered={onFirstDataRendered}
              ></AgGridReact>
            </div>
          </div>
        ) : (
          <div
            className="col-md-12 col-sm-12 row-10 ag-theme-alpine"
            style={{
              height: "80vh",
              width: "80vw",
              margin: "auto",
            }}
          >
            <div
              onClick={() => {
                setCellClickData(null);
              }}
              className="col-md-12 col-sm-12 row-4 icon icon-shape icon-l  me-12"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                margin: "2px 0 2px 0px",
              }}
            >
              <div className="ms-md-auto pe-md-3 d-flex align-items-center">
                <div className="input-group">
                  <span className="input-group-text text-body">
                    <i className="fas fa-search" aria-hidden="false"></i>
                  </span>
                  <input
                    aria-label="Search"
                    autoComplete={"false"}
                    data-html={true}
                    data-tip="&amp;#8226; Use atleast 12 characters.<br />
                                                      &amp;#8226; Include both lowercase and uppercase characters.<br />
                                                      &amp;#8226; Include atleast one number or symbol.<br />
                                                      &amp;#8226; Password should not be based on any personal information such as user id, family name, pet, birthday, friends, co-workers, addresses, phone numbers, etc."
                    aria-describedby="basic-addon2"
                    type="text"
                    className="form-control"
                    placeholder="Type here..."
                    onChange={(value) => {
                      let filterData = [];
                      if (value.target?.value == "") {
                        filterData = rowDataRural;
                        setRowData(filterData);
                      } else {
                        filterData = rowDataRural?.filter((item) => {
                          return (
                            item.btId
                              ?.toLowerCase()
                              ?.includes(value.target.value.toLowerCase()) ||
                            item.currentLocation
                              ?.toLowerCase()
                              ?.includes(value.target.value.toLowerCase()) ||
                            item.currentLoad
                              ?.toLowerCase()
                              ?.includes(value.target.value.toLowerCase()) ||
                            item.trailer?.btId?.includes(value.target.value) ||
                            item.condition
                              ?.toLowerCase()
                              ?.includes(value.target.value?.toLowerCase()) ||
                            item.designationLocation
                              ?.toLowerCase()
                              ?.includes(value.target.value?.toLowerCase()) ||
                            item.status
                              ?.toLowerCase()
                              ?.includes(value.target.value?.toLowerCase())
                          );
                        });
                        setRowData(filterData);
                      }
                    }}
                  ></input>
                </div>
              </div>

              {isShowLog ||
              (loginResponse &&
                ((loginResponse?.user?.userRoles[0]?.user_role_name ==
                  CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
                  loginResponse?.user?.userRoles[0]?.priority) ||
                  (loginResponse?.user?.userRoles[0]?.user_role_name ==
                    CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                    loginResponse?.user?.userRoles[0]?.priority))) ? (
                <p
                  style={{
                    fontSize: 14,
                    textAlign: "center",
                    backgroundColor: "lightBlue",
                    borderRadius: 8,
                    marginLeft: 14,
                    padding: 6,
                    margin: 0,
                  }}
                  onClick={() => {
                    let exportData = [];

                    for (let i = 0; i < rowData?.length; i++) {
                      let data = {
                        "Trailer No": rowData[i]?.btId,
                        "Current Location": rowData[i]?.designationLocation,
                        "Trailer Capacity": rowData[i].currentLoad,
                        Status: rowData[i].status,
                        "Seal Number": rowData[i].sealNum,
                        "Product Number": rowData[i].productNum,
                        actualCount: rowData[i].actualCount,
                      };
                      exportData[i] = data;
                    }

                    exportFile("TrailerReport", exportData, [
                      "Trailer No",
                      "Current Location",
                      "Trailer Capacity",
                      "Status",
                      "Seal Number",
                      "Product Number",
                      "Actual Count",
                    ]);
                  }}
                >
                  EXPORT
                </p>
              ) : null}
            </div>
            <AgGridReact
              ref={gridRef}
              suppressColumnVirtualisation={true}
              defaultColDef={defaultColDef}
              animateRows={true}
              onCellClicked={cellClickedListener}
              rowData={rowData}
              pagination={false}
              paginationAutoPageSize={false}
              paginationPageSize={10}
              paginateChildRows={false}
              enableRangeSelection={false}
              suppressRowClickSelection={false}
              groupSelectsChildren={false}
              rowSelection={"multiple"}
              rowGroupPanelShow={"always"}
              pivotPanelShow={"always"}
              columnDefs={columnDefs}
              onFirstDataRendered={onFirstDataRendered}
            ></AgGridReact>
          </div>
        )}
      </div>
    </div>
  );
};
export default TrailersComp;
